var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6349 17H5.36505C4.36129 17 3.54758 16.2007 3.54758 15.2147V8.57964C3.54758 8.06342 2.91221 7.8049 2.54061 8.16992C2.20135 8.50317 1.62054 8.32034 1.54167 7.85546L1.0248 4.80914C0.902057 4.08569 1.24222 3.36209 1.88247 2.98474L5.19652 1.03149C5.29304 0.974606 5.41751 0.99658 5.48783 1.08292C7.2884 3.29381 10.7116 3.29381 12.5122 1.08292C12.5825 0.99658 12.707 0.974606 12.8035 1.03149L16.1175 2.98474C16.7578 3.36209 17.0979 4.08569 16.9752 4.80914L16.4583 7.85546C16.3795 8.32034 15.7986 8.50317 15.4594 8.16992C15.0878 7.8049 14.4524 8.06342 14.4524 8.57964V15.2147C14.4524 16.2007 13.6387 17 12.6349 17Z",
    stroke: "#3C4242",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeIcon);
export default __webpack_public_path__ + "static/media/size_icon.c48c9c13b289f1082f2c94b6a6bd0cb5.svg";
export { ForwardRef as ReactComponent };